import { HttpClient } from '@angular/common/http';
import { Injectable, QueryList } from '@angular/core';
import { SfUtils, SmartFormComponent } from 'ngx-smart-form';
import { forkJoin, map, Observable, of } from 'rxjs';
import { AddDoc } from 'src/app/anagraphics/add-doc-anagraphic/add-doc';
import { environment } from 'src/environments/environment';
import { UploadedDocument } from '../models/uploaded-document';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly queryEndpoint = `${environment.api}/document-query/documento`;
  private readonly commandEndpoint = `${environment.api}/document-command/documento`;
  private readonly conservaEndpoint = `${environment.api}/camunda/api/v1/process/document-storage-ca/start`;

  constructor(private http: HttpClient) {}

  getByPratica(praticaId: string) {
    return this.http.get<UploadedDocument[]>(
      `${this.queryEndpoint}/pratica/${praticaId}`
    );
  }

  getByAnagrafica(anagraficaId: string) {
    return this.http.get<UploadedDocument[]>(
      `${this.queryEndpoint}/anagrafica/${anagraficaId}`
    );
  }

  store(documentId: string, praticaId: string) {
    return this.http.post(`${this.conservaEndpoint}`, {
      idDocument: documentId,
      idPratica: praticaId,
    });
  }

  private add(
    document: File,
    documentType: string,
    identificativo: string,
    anagraficaId: string | undefined,
    praticaId: string | undefined
  ) {
    let data = new FormData();
    data.append('tipo', documentType);
    data.append('file', document);
    data.append('identificativo', identificativo || '');
    if (anagraficaId) {
      data.append('anagrafica', anagraficaId);
    } else if (praticaId) {
      data.append('pratica', praticaId);
    }
    console.log(data);
    return this.http
      .post<{ id: string }>(this.commandEndpoint, data)
      .pipe(map((res) => ({ name: documentType, id: res.id })));
  }

  delete(doc: UploadedDocument) {
    //return of(data);
    return this.http
      .delete(`${this.commandEndpoint}/${doc.id}`)
      .pipe(map((res) => true));
  }

  multiUpload(
    addDocFormValue: Record<
      string,
      File | FileList | UploadedDocument | undefined
    >,
    identificativo: string | undefined,
    anagraficaId: string | undefined,
    praticaId: string | undefined
  ) {
    const request$: Observable<{ name: string; id: string }>[] = [];
    for (let key in addDocFormValue) {
      if (
        !!addDocFormValue[key] &&
        typeof addDocFormValue[key] === 'object' &&
        !addDocFormValue[key]?.['id']
      ) {
        if (addDocFormValue[key] instanceof FileList) {
          let fileList = addDocFormValue[key] as FileList;
          for (let i = 0; i < fileList.length; i++) {
            let request = this.add(
              fileList[i] as File,
              key + '_' + (i + 1),
              identificativo || '',
              anagraficaId,
              praticaId
            );
            request$.push(request);
          }
        } else {
          let request = this.add(
            addDocFormValue[key] as File,
            key,
            identificativo || '',
            anagraficaId,
            praticaId
          );
          request$.push(request);
        }
      }
    }
    return request$.length > 0 ? forkJoin(request$) : of([]);
  }

  getByUser(userId: string) {
    return this.http.get<UploadedDocument[]>(
      `${this.queryEndpoint}/user/${userId}`
    );
  }
}
